import { render, staticRenderFns } from "./AddDemandeReglement.vue?vue&type=template&id=c0d64c8c&"
import script from "./AddDemandeReglement.vue?vue&type=script&lang=js&"
export * from "./AddDemandeReglement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports